import { Box, Typography, Card, CardContent } from "@mui/material";
import React from "react";
import "./Reviews.css";
import { Images } from "../../../../helpers/Images";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { isMobile } from "react-device-detect";
import { reviews } from "../../../../helpers/Arrays";

const Reviews = () => {
  return (
    <Box
      className="reviews-section"
      sx={{
        width: "100%",
        padding: {
          xs: "50px 20px 100px 20px",
          sm: "50px 60px 100px 60px",
          lg: "70px 120px",
        },
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        backgroundColor: "secondary.main",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          maxWidth: "1400px",
          margin: "0 auto",
          width: "100%",
          position: "relative",
          zIndex: 1,
        }}
      >
        <Typography
          variant="h2"
          className="reviews-title"
          sx={{
            textAlign: "center",
            fontSize: { xs: "32px", sm: "42px" },
            fontWeight: "700",
            color: "primary.darker",
            marginBottom: "12px",
            letterSpacing: "-0.5px",
          }}
        >
          What people are saying..
        </Typography>
        <Box
          sx={{
            height: "4px",
            width: { xs: "120px", md: "180px" },
            background:
              "linear-gradient(90deg, transparent, #830d0b, transparent)",
            margin: "0 auto 30px auto",
            borderRadius: "2px",
            // boxShadow: "0 2px 8px rgba(131, 13, 11, 0.3)",
          }}
        />
        <Box sx={{ width: "100%", margin: "auto", position: "relative" }}>
          <Carousel
            showStatus={false}
            showThumbs={false}
            showArrows={true}
            showIndicators={false}
            infiniteLoop={true}
            autoPlay={true}
            interval={5000}
            centerMode={isMobile ? false : true}
            centerSlidePercentage={50}
            className="reviews-carousel"
            renderArrowPrev={(onClickHandler, hasPrev) => (
              <Box
                className={`carousel-arrow carousel-arrow-prev ${
                  hasPrev ? "active" : ""
                }`}
                onClick={onClickHandler}
                sx={{
                  width: { xs: "50px", md: "60px" },
                  height: { xs: "50px", md: "60px" },
                  cursor: "pointer",
                  position: "absolute",
                  zIndex: 2,
                  left: { xs: "10px", md: "-80px" },
                  top: { xs: "unset", md: "calc(50% - 30px)" },
                  bottom: { xs: "-70px", md: "unset" },
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "rgba(255, 255, 255, 0.95)",
                  borderRadius: "50%",
                  boxShadow: "0 4px 16px rgba(0, 0, 0, 0.15)",
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                  border: "2px solid rgba(131, 13, 11, 0.1)",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 1)",
                    transform: "scale(1.1)",
                    boxShadow: "0 6px 24px rgba(131, 13, 11, 0.25)",
                    borderColor: "primary.main",
                  },
                }}
              >
                <img
                  alt="prev"
                  src={Images.prevArrow}
                  style={{
                    width: "60%",
                    height: "60%",
                    filter:
                      "invert(13%) sepia(48%) saturate(5796%) hue-rotate(350deg) brightness(103%) contrast(93%)",
                  }}
                />
              </Box>
            )}
            renderArrowNext={(onClickHandler, hasNext) => (
              <Box
                className={`carousel-arrow carousel-arrow-next ${
                  hasNext ? "active" : ""
                }`}
                onClick={onClickHandler}
                sx={{
                  width: { xs: "50px", md: "60px" },
                  height: { xs: "50px", md: "60px" },
                  cursor: "pointer",
                  position: "absolute",
                  zIndex: 2,
                  right: { xs: "10px", md: "-80px" },
                  top: { xs: "unset", md: "calc(50% - 30px)" },
                  bottom: { xs: "-70px", md: "unset" },
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "rgba(255, 255, 255, 0.95)",
                  borderRadius: "50%",
                  boxShadow: "0 4px 16px rgba(0, 0, 0, 0.15)",
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                  border: "2px solid rgba(131, 13, 11, 0.1)",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 1)",
                    transform: "scale(1.1)",
                    boxShadow: "0 6px 24px rgba(131, 13, 11, 0.25)",
                    borderColor: "primary.main",
                  },
                }}
              >
                <img
                  alt="next"
                  src={Images.nextArrow}
                  style={{
                    width: "60%",
                    height: "60%",
                    filter:
                      "invert(13%) sepia(48%) saturate(5796%) hue-rotate(350deg) brightness(103%) contrast(93%)",
                  }}
                />
              </Box>
            )}
          >
            {reviews?.map((item, i) => (
              <Box key={i} sx={{ padding: { xs: "0 10px", md: "0 15px" } }}>
                <Card
                  className="review-card"
                  sx={{
                    width: "100%",
                    minHeight: { xs: "270px" },
                    borderRadius: "24px",
                    boxShadow: "0 0px 15px rgba(131, 13, 11, 0.15)",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                    backgroundColor: "secondary.main",
                    border: "1px solid rgba(131, 13, 11, 0.1)",
                    padding: {
                      xs: "20px 30px",
                    },
                    transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                    "&:hover": {
                      boxShadow: "0 16px 48px rgba(131, 13, 11, 0.2)",
                      borderColor: "primary.main",
                    },
                  }}
                >
                  <Box
                    component="img"
                    alt="quote"
                    src={Images.quote}
                    className="quote-icon quote-icon-top"
                    sx={{
                      position: "absolute",
                      top: { xs: "20px", sm: "30px", md: "40px" },
                      left: { xs: "20px", sm: "30px", md: "40px" },
                      opacity: 0.08,
                      filter:
                        "invert(13%) sepia(48%) saturate(5796%) hue-rotate(350deg) brightness(103%) contrast(93%)",
                    }}
                  />
                  <CardContent
                    sx={{
                      padding: "0 !important",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      width: "100%",
                      position: "relative",
                      zIndex: 1,
                    }}
                  >
                    <Typography
                      variant="h5"
                      className="review-text"
                      sx={{
                        textAlign: "center",
                        fontSize: { xs: "18px", sm: "22px" },
                        fontWeight: "400",
                        color: "primary.darker",
                        lineHeight: 1.8,
                        marginBottom: { xs: "10px" },
                        maxWidth: "85%",
                        fontStyle: "italic",
                      }}
                    >
                      {item.review}
                    </Typography>
                    <Box
                      sx={{
                        height: "3px",
                        width: { xs: "60px", sm: "80px" },
                        background:
                          "linear-gradient(90deg, transparent, #830d0b, transparent)",
                        marginBottom: { xs: "24px", sm: "30px" },
                        borderRadius: "2px",
                      }}
                    />
                    <Typography
                      variant="h6"
                      sx={{
                        textAlign: "center",
                        fontSize: { xs: "18px", sm: "20px" },
                        fontWeight: "700",
                        color: "primary.main",
                        marginBottom: "4px",
                        letterSpacing: "0.5px",
                      }}
                    >
                      {item.name}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        textAlign: "center",
                        fontSize: { xs: "14px", sm: "15px" },
                        fontWeight: "400",
                        color: "rgba(0, 0, 0, 0.6)",
                        letterSpacing: "0.3px",
                      }}
                    >
                      {item.date}
                    </Typography>
                  </CardContent>
                  <Box
                    component="img"
                    alt="quote"
                    src={Images.quote}
                    className="quote-icon quote-icon-bottom"
                    sx={{
                      position: "absolute",
                      bottom: { xs: "20px", sm: "30px", md: "40px" },
                      right: { xs: "20px", sm: "30px", md: "40px" },
                      transform: "rotate(180deg)",
                      opacity: 0.08,
                      filter:
                        "invert(13%) sepia(48%) saturate(5796%) hue-rotate(350deg) brightness(103%) contrast(93%)",
                    }}
                  />
                </Card>
              </Box>
            ))}
          </Carousel>
        </Box>
      </Box>
    </Box>
  );
};

export default Reviews;

// RobotChallenge is one of the biggest competitions for self-made, autonomous and mobile robots worldw
